/* eslint-disable no-param-reassign */
import _ from 'lodash';
import * as R from 'ramda';
import { tagTypes, handleCreateName, parseName, handleCreateYear, constants } from '@enotarylog/tag-utils';
import loadImg from '../helpers/loadImg';
import debug from 'debug';
import moment from 'moment';
import { defaultFontSize } from '@enotarylog/tag-utils';
import {
  checkIfAllSignerRequiredTags,
  checkIfAnySignerRequiredTags,
  showToastMessage,
} from "@enotarylog/shared";
import { toast } from 'react-toastify';

const log = debug('vanilla:lib');
const { documentCompletionTags } = constants;

const handleCreateDate = (instance, date, annot, customType, _formatStr) => {
  let formatStr = _formatStr;
  console.log(formatStr);
  if (formatStr === 'dd/MM/yy') {
    formatStr = 'DD/MM/YY';
  }

  if (formatStr === 'MM/dd/yy') {
    formatStr = 'MM/DD/YY';
  }

  if (formatStr === "MM/dd/yyyy") {
    formatStr = 'MM/DD/YYYY';
  }

  if (formatStr === 'MMMM do, yyyy') {
    formatStr = 'MMMM Do, YYYY';
  }
  if (formatStr === 'do') {
    formatStr = 'Do';
  }

  formatStr = formatStr.replace('dd','DD'); // dd => Su Mo ... Fr Sa, DD => 01 02 ... 30 31)

  const dateStr = moment(date).format(formatStr);
  return handleCreateName(instance, dateStr, annot, customType, formatStr)
};

const handleTemplateDoubleClick = ({ instance, config }) => async (annot) => {
  const areDocumentValidationsEnabled = instance.getEnableValidations();

  if (areDocumentValidationsEnabled) {
    const annotListed = instance?.annotManager?.getAnnotationsList();
    const isAdmin = instance?.annotManager?.getIsAdminUser();
    const signers = instance?.getSigners();
    const filterSigner = signers.filter(e => {
      return e?.type === 'consumer' || e?.type === 'witness' ? e.userId : false;
    });
    const consumersIds = filterSigner.map(a => a.userId);
    const filteredAnnots = annotListed.filter(e => {
      return e?.Subject === 'NotarySealAnnotation' || (e?.Subject === 'Signature' && !consumersIds.includes(e?.Author));
    });
    const hasNotarySignSealedDocument = documentCompletionTags.every(value => {
      return filteredAnnots.find(e => e?.Subject === value);
    });

    if(!isAdmin && hasNotarySignSealedDocument) {
      return toast.error('You cannot alter this document once the Notary has placed their Signature and Stamp. Please alert your Notary if you need to make any changes.');
    }
  }

  if (annot && annot.Subject && (annot.Subject.includes('Template') || annot.CustomData?.type === tagTypes.imageTags.FREEFORMTEXTTAGTEMPLATEANNOTATION.type)) {
    const { getSessionStatus } = config;

    const isRequired = annot?.CustomData?.flags?.required;
    // check if it is for the selected signer and authedUser exists
    const currentUser = instance.annotManager.getCurrentUser();

    if ((!currentUser || currentUser === '-1' || currentUser === 'guest') && annot.CustomData.name?.trim() !== 'Notary' && annot.CustomData.signerId !== currentUser) {
      return;
    }

    const nsId = config.nsId;

    if (!nsId) {
      // Tag created on upload.
      return;
    }

    let onSignatureModalClosed;

    // NOTE: sorting. consumer first, then others are sorted by lastName, then firstName
    const onAnnotationAdded = async (copiedSig) => {
      const sigTool = instance.docViewer.getTool('AnnotationCreateSignature');

      if(copiedSig.Color){
        sigTool.setStyles(currentStyle => ({
          StrokeColor: copiedSig.Color,
        }))
      }

      const maxX = instance.docViewer.getPageWidth(annot.PageNumber - 1);

      const rotation = instance.docViewer.getCompleteRotation(1) * 90;
      if(rotation === 270 || rotation === 90){
        annot.Width =  72;
        annot.Height = 150;
      }
      if(rotation === 180){
        annot.Width =  72;
      }

      const imageRatio = copiedSig.Width / copiedSig.Height;
      let decidedWidth = annot.Height * imageRatio;
      let decidedHeight = annot.Height;

      if (decidedWidth > annot.Width) {
        decidedWidth = annot.Width;
        decidedHeight = decidedWidth / imageRatio;
      }

      const sigType = (annot.CustomData.type === 'SIGNHERETAGTEMPLATEANNOTATION' || annot.CustomData.type === 'SIGNATURETEMPLATE') ? 'signature' : 'initials';

      // This centers the signature/initials in the center of the template annotation.
      const hs = _.isNaN((annot.Height - decidedHeight) / 2) ? 0 : (annot.Height - decidedHeight) / 2;
      const ws = _.isNaN((annot.Width - decidedWidth) / 2) ? 0 : (annot.Width - decidedWidth) / 2;
      const offsetX = Math.max(0, ws);
      const offsetY = Math.max(0, hs);

      //Commented as effecting rotation functionality
      // Prevent x2 from being placed outside the document while maintaing signature aspect
      let x2 = annot.X + offsetX + decidedWidth;

      if (decidedWidth > annot.width || x2 > maxX) {
        decidedWidth = maxX - annot.X;
        decidedHeight = decidedWidth / imageRatio;
      }

      x2 = Math.min(maxX, annot.X + offsetX + decidedWidth);
      const rect = new instance.Annotations.Rect(annot.X + offsetX, annot.Y + offsetY, x2, annot.Y + offsetY + decidedHeight);

      copiedSig.resize(rect);
      copiedSig.MaintainAspectRatio = true;
      copiedSig.CustomData.corrId = annot.Id;
      copiedSig.CustomData.forEnote = annot.CustomData.forEnote;
      copiedSig.CustomData.type = sigType;

      if (isRequired) {
        log('locking contents');
        copiedSig.CustomData.flags = { required: isRequired };
        copiedSig.NoMove = true;
        copiedSig.LockedContents = true;
        copiedSig.ContentLocked = true;
      }

      sigTool.off('signatureModalClosed', onSignatureModalClosed);
      sigTool.off('annotationAdded', onAnnotationAdded);
      // return server.setHideAnnotation(annot.Id, true);
    };

    const onSignatureCreated = () => {
      const sigTool = instance.docViewer.getTool('AnnotationCreateSignature');
      const signature = sigTool.annot;

      sigTool.hidePreview();

      sigTool.location = {
        pageIndex: annot.PageNumber - 1,
        x: annot.X + (signature.Width / 4),
        y: annot.Y + annot.Height - (signature.Height / 4),
      };
      log('calling off(2) with', typeof onSignatureModalClosed);
      sigTool.off('signatureModalClosed', onSignatureModalClosed);
    };

    onSignatureModalClosed = () => {
      const sigTool = instance.docViewer.getTool('AnnotationCreateSignature');

      // clean up event listensers that were attached when create signature modal opened
      sigTool.off('signatureSaved', onSignatureCreated);

      // NOTE: hacky workaround to be able remove any custom `signatureSaved` listeners b/c sigTool.off doesn't work
      if (sigTool._events.signatureSaved.length > 3) {
        const [a, b, c] = sigTool._events.signatureSaved;


        sigTool._events.signatureSaved = _.filter(sigTool._events.signatureSaved, (e) => e.handler !== onSignatureCreated);
      }

      setTimeout(() => {
        sigTool.off('signatureCreated', onSignatureCreated);
        sigTool.off('annotationAdded', onAnnotationAdded);
      }, 1000);
    };

    const currUserId = instance.annotManager.getCurrentUser();
    const currUser = instance.getSignerById(currUserId);

    // if meant for notary but user is not admin, then return
    if (annot.CustomData.name?.includes('Notary') && !instance.annotManager.getIsAdminUser()) {
      return;
    }

    // if not meant for notary and not assigned to currentUser, return.
    if (R.not(annot.CustomData.name?.includes('Notary')) && annot.CustomData.signerId !== currUserId) {
      return;
    }

    /*
      Blocking notaries from executing signature and commission stamp tags if there were any signer
      required tags pending in the document.

      NOTE: Despite being the 'Commission Stamp Tag' the annotation has a type of
      'SEALTAGTEMPLATEANNOTATION'.
    */
    if (
      instance.annotManager.getIsAdminUser() &&
      annot.CustomData.name?.includes('Notary') &&
      (annot.CustomData.type === 'SIGNHERETAGTEMPLATEANNOTATION' || annot.CustomData.type === 'SEALTAGTEMPLATEANNOTATION')
    ) {
      const annotations = instance.annotManager.getAnnotationsList();
      const allRequiredTagsAreSigned = checkIfAllSignerRequiredTags(annotations);

      let sessionStatus = 'pending_start';

      if (getSessionStatus) {
        sessionStatus = await getSessionStatus();
      }

      if (!allRequiredTagsAreSigned) {
        // We only show the toast if the session was in progress.
        if (sessionStatus === 'in_progress') {
          showToastMessage(window, {
            type: "error",
            message: "Required signer tags on current document must be completed before the notary can affix their stamp and signature",
          });
        }

        return;
      }
    }

    // if it is a signature/initials template
    if (annot.CustomData.type === 'SIGNHERETAGTEMPLATEANNOTATION'
      || annot.CustomData.type === 'INITIALHERETAGTEMPLATEANNOTATION'
      || annot.CustomData.type === 'SIGNATURETEMPLATE'
      || annot.CustomData.type === 'INITIALSTEMPLATE'
    ) {
      const sigTool = instance.docViewer.getTool('AnnotationCreateSignature');
      const sigs = sigTool.getSavedSignatures();
      const sigType = (annot.CustomData.type === 'SIGNHERETAGTEMPLATEANNOTATION' || annot.CustomData.type === 'SIGNATURETEMPLATE') ? 'signature' : 'initials';

      // if no signature/initials defined then show SignatureModal
      const signature = _.find(sigs, (sig) => sig.CustomData.type === sigType);

      if (!signature) {
        sigTool.on('annotationAdded', onAnnotationAdded);
        sigTool.one('signatureSaved', onSignatureCreated);
        sigTool.one('signatureModalClosed', onSignatureModalClosed);

        // eslint-disable-next-line consistent-return
        return instance.store.dispatch({
          type: 'OPEN_SIGNATURE_MODAL',
          payload: { type: sigType },
        });
      }

      sigTool.location = {
        pageIndex: annot.PageNumber - 1,
        x: annot.X + (signature.Width / 2),
        y: annot.Y + annot.Height - (signature.Height / 2),
      };

      let sigCopy;

      if (signature instanceof instance.Annotations.FreeHandAnnotation) {
        sigCopy = new instance.Annotations.FreeHandAnnotation();
        sigCopy.MaintainAspectRatio = true;
        signature.getPaths().map((points, index) => sigCopy.setPath(points, index));
        sigCopy.Width = signature.Width;
        sigCopy.Height = signature.Height;
        sigCopy.setRect(new instance.Annotations.Rect(signature.getRect()));
        sigCopy.Color = new instance.Annotations.Color(signature.Color);
        sigCopy.StrokeThickness = annot.StrokeThickness;
        sigCopy.CustomData = _.cloneDeep(signature.CustomData);
        sigCopy.CustomData.forEnote = annot.CustomData.forEnote;
      } else {
        sigCopy = new instance.Annotations.StampAnnotation();
        sigCopy.MaintainAspectRatio = true;
        sigCopy.ImageData = signature.ImageData;
        sigCopy.Color = new instance.Annotations.Color(signature.Color);
        sigCopy.Width = signature.Width;
        sigCopy.Height = signature.Height;
        sigCopy.setRect(new instance.Annotations.Rect(signature.getRect()));
        sigCopy.CustomData = _.cloneDeep(signature.CustomData);
        sigCopy.CustomData.forEnote = annot.CustomData.forEnote;
      }

      if (annot?.CustomData?.flags?.required) {
        sigCopy.NoMove = true;
        sigCopy.LockedContents = true;
      }

      sigTool.one('annotationAdded', onAnnotationAdded);
      sigCopy.setHeight(annot.Height);
      sigCopy.CustomData.corrId = annot.Id;
      sigCopy.CustomData.type = sigType;
      sigCopy.CustomData.flags = annot?.CustomData?.flags;
      sigTool.annot = sigCopy;
      sigTool.setSignature(sigCopy);
      sigTool.addSignature();
    } else if (annot.CustomData.type in tagTypes.nameTags) {
      const field = tagTypes.nameTags[annot.CustomData.type].field;
      instance.docViewer.trigger('getCommissionName', annot);

      const name = (field === 'fullName')
        ? currUser ? parseName(currUser.user) : annot.commissionName
        : currUser.user[tagTypes.nameTags[annot.CustomData.type].field];
      handleCreateName(instance, name, annot);
    } else if (annot.CustomData.type in tagTypes.notaryVerbiageTags) {
      instance.docViewer.trigger('createNotaryVerbiageAnnotation', annot);
    } else if (annot.CustomData.type === tagTypes.imageTags.SEALTAGTEMPLATEANNOTATION.type) {
      const stamp = new instance.Annotations.StampAnnotation();

      if (annot?.CustomData?.flags?.required) {
        stamp.NoMove = true;
        stamp.LockedContents = true;
      }

      stamp.ImageData = _.get(config.images, 'seal');
      const img = await loadImg(stamp.ImageData);

      // scale the image to the correct height of the template annot
      const tagAspectRatio = annot.Width / annot.Height;
      const imgAspectRatio = img.width / img.height;

      const rotation = instance.docViewer.getCompleteRotation(annot.PageNumber || 1) * 90;
      if(rotation === 180 || rotation === 0){
        annot.Width =  150;
      }
      if (tagAspectRatio > imgAspectRatio) {
        // The tag is wider than the stamp, so the tag's height must be used for the calculations because it's smaller (proportionally)
        stamp.Height = annot.Height;
        stamp.Width = annot.Height * (img.width / img.height);
      } else {
        // The tag isn't wider than the stamp, so the tag's width is smaller than or the same size as the stamp, proportionally
        stamp.Height = annot.Width * (img.height / img.width);
        stamp.Width = rotation === 180 ?  150 : annot.Width;
      }

      if (rotation === 270 || rotation === 90) {
        const height = 70.01919385796545;
        const width = 150;
        stamp.Height = width;
        stamp.Width = height;
      }
      stamp.setPageNumber(annot.PageNumber);
      stamp.Subject = 'NotarySealAnnotation';
      stamp.X = (annot.X + (annot.Width / 2)) - (stamp.Width / 2);
      stamp.Y = annot.Y;
      stamp.Rotation = rotation
      stamp.MaintainAspectRatio = true;
      stamp.CustomData.corrId = annot.Id;
      stamp.CustomData.flags = annot?.CustomData?.flags;
      await instance.annotManager.addAnnotation(stamp);
      await instance.annotManager.redrawAnnotation(stamp);
      log('this is a seal annot', stamp);

      annot.Author = instance.annotManager.getCurrentUser();
    } else if (annot.CustomData.type in tagTypes.dateTags) {
      handleCreateDate(instance, new Date(), annot, annot.CustomData.type, annot.CustomData.flags.dateFormat);
    } else if (annot.CustomData.type in tagTypes.yearTags) {
      handleCreateYear(instance, new Date(), annot, annot.CustomData.type, annot.CustomData.flags.yearFormat);
    } else if (annot.CustomData.type === tagTypes.imageTags.CHECKHERETAGTEMPLATEANNOTATION.type) {
      const stamp = new instance.Annotations.StampAnnotation();

      // eslint-disable-next-line max-len
      stamp.ImageData = 'data:image/png;base64,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';
      const img = await loadImg(stamp.ImageData);

      // scale the image to the correct height of the template annot
      const tagAspectRatio = annot.Width / annot.Height;
      const imgAspectRatio = img.width / img.height;
      const rotation = instance.docViewer.getCompleteRotation(1) * 90;

      if (tagAspectRatio > imgAspectRatio) {
        // The tag is wider than the stamp, so the tag's height must be used for the calculations because it's smaller (proportionally)
        stamp.Height = annot.Height;
        stamp.Width = annot.Height * (img.width / img.height);
      } else {
        // The tag isn't wider than the stamp, so the tag's width is smaller than or the same size as the stamp, proportionally
        stamp.Height = annot.Width * (img.height / img.width);
        stamp.Width = annot.Width;
      }

      stamp.setPageNumber(annot.PageNumber);
      stamp.Subject = 'CheckBoxAnnotation';
      stamp.X = (annot.X + (annot.Width / 2)) - (stamp.Width / 2);
      stamp.Y = annot.Y;
      stamp.Rotation = rotation;
      stamp.MaintainAspectRatio = true;
      stamp.CustomData.corrId = annot.Id;
      stamp.CustomData.flags = annot?.CustomData?.flags;
      stamp.Author = await instance.annotManager.getCurrentUser();
      log('this is a checkbox annot', stamp);

      await instance.annotManager.addAnnotation(stamp);
      await instance.annotManager.redrawAnnotation(stamp);
    } else if (annot.CustomData.type === tagTypes.imageTags.FREEFORMTEXTTAGTEMPLATEANNOTATION.type) {
      const freeText = new instance.Annotations.FreeTextAnnotation();
      const rotation = instance.docViewer.getCompleteRotation(annot.PageNumber || 1) * 90;

      freeText.X = annot.X;
      freeText.Y = annot.Y;
      freeText.Width = annot.Width;
      freeText.Height = annot.Height;
      freeText.FontSize = defaultFontSize;
      freeText.PageNumber = annot.PageNumber;
      freeText.setPadding(new instance.Annotations.Rect(0, 0, 0, 0));
      freeText.StrokeColor = new instance.Annotations.Color(255, 255, 255, 0);
      freeText.StrokeThickness = 0;
      freeText.Rotation = rotation;
      freeText.TextColor = new instance.Annotations.Color(0, 0, 0);
      freeText.CustomData.corrId = annot.Id;
      freeText.CustomData.type = annot.type;
      freeText.CustomData.name = annot.name;
      freeText.CustomData.signerId = annot.signerId;
      freeText.Author = instance.annotManager.getCurrentUser();
      freeText.setContents('Insert text here');

      if (annot.CustomData?.flags?.required) {
        freeText.NoMove = true;
      }

      log('this is a freetext annot', freeText);

      await instance.setToolMode('AnnotationEdit');
      await instance.annotManager.addAnnotation(freeText);
      await instance.annotManager.redrawAnnotation(freeText);
      await instance.setToolMode('AnnotationEdit');
    } else if (annot.CustomData.type === tagTypes.imageTags.RADIOBUTTONTAGTEMPLATEANNOTATION.type) {
      const stamp = new instance.Annotations.StampAnnotation();


      // eslint-disable-next-line max-len
      stamp.ImageData = 'data:image/png;base64,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';
      const img = await loadImg(stamp.ImageData);

      // scale the image to the correct height of the template annot
      const tagAspectRatio = annot.Width / annot.Height;
      const imgAspectRatio = img.width / img.height;

      if (tagAspectRatio > imgAspectRatio) {
        // The tag is wider than the stamp, so the tag's height must be used for the calculations because it's smaller (proportionally)
        stamp.Height = annot.Height;
        stamp.Width = annot.Height * (img.width / img.height);
      } else {
        // The tag isn't wider than the stamp, so the tag's width is smaller than or the same size as the stamp, proportionally
        stamp.Height = annot.Width * (img.height / img.width);
        stamp.Width = annot.Width;
      }

      stamp.setPageNumber(annot.PageNumber);
      stamp.Subject = 'RadioButtonAnnotation';
      stamp.X = (annot.X + (annot.Width / 2)) - (stamp.Width / 2);
      stamp.Y = annot.Y;
      stamp.MaintainAspectRatio = true;
      stamp.CustomData.corrId = annot.Id;
      stamp.CustomData.flags = annot?.CustomData?.flags;
      stamp.Author = instance.annotManager.getCurrentUser();
      log('this is a radio annot', stamp);
      await instance.annotManager.addAnnotation(stamp);
      await instance.annotManager.redrawAnnotation(stamp);
    } else {
      instance.docViewer.trigger('openPromptModal', { id: annot.Id, CustomData: annot.CustomData });
    }

    log('this is the annot being hidden', annot);
    instance.annotManager.hideAnnotations([annot])
    await instance.annotManager.trigger('annotationUpdated', [{
      id: annot.Id,
      hidden: true,
    }]);
  }
};

const handleTemplateDblClick = () => ({ instance, ...rest }) => {
  const handleDblClick = handleTemplateDoubleClick({ instance, ...rest });

  instance.annotManager.off('annotationDoubleClicked', handleDblClick);
  instance.annotManager.on('annotationDoubleClicked', handleDblClick);

  return {
    instance,
    ...rest,
  };
};

export default handleTemplateDblClick;
